import type { ReactElement } from 'react'
import { AlertDialog, Button } from '@buffer-mono/popcorn'

type ComponentPropTypes = {
  open: boolean
  setOpen: (open: boolean) => void
  onConfirm: () => void
  onCancel?: () => void
}

export const BackToOmniConfirmationModal = ({
  open,
  setOpen,
  onConfirm,
  onCancel,
}: ComponentPropTypes): ReactElement => {
  const handleCancel = (): void => {
    onCancel?.()
    setOpen(false)
  }

  const handleConfirm = (): void => {
    onConfirm()
    setOpen(false)
  }

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialog.Content>
        <AlertDialog.Title>You May Lose Your Changes</AlertDialog.Title>
        <AlertDialog.Description>
          Going back to the previous step will discard any changes you&apos;ve
          made for each channel.
        </AlertDialog.Description>
        <AlertDialog.Actions>
          <AlertDialog.Cancel>
            <Button variant="tertiary" onClick={handleCancel}>
              Cancel
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button variant="critical" onClick={handleConfirm}>
              Go Back
            </Button>
          </AlertDialog.Action>
        </AlertDialog.Actions>
      </AlertDialog.Content>
    </AlertDialog>
  )
}
